import { getFunctions, httpsCallable } from "firebase/functions";
import { firebaseApp } from "./firebase";
export type CentralFuneralHomeLocation = {
  id: string;
  name: string;
  address: string;
  active: boolean;
};
export type CentralFuneralHomePreferences = {
  defaultLocationId: string | null;
  familyAccess: "secure_link" | "public_preview";
  priceVisibility: "director_review" | "family_visible";
  notificationEmail: string;
};
export type CentralFuneralHomeSettings = {
  address: string;
  locations: CentralFuneralHomeLocation[];
  name: string;
  phone: string;
  preferences: CentralFuneralHomePreferences;
  updatedAt: string | null;
  website: string;
};
const functions = getFunctions(firebaseApp, "us-east1");
export async function getCentralCaseLocations() {
  const callable = httpsCallable<
    undefined,
    {
      defaultLocationId: string | null;
      locations: CentralFuneralHomeLocation[];
    }
  >(functions, "getCentralCaseLocations");
  return (await callable(undefined)).data;
}
export async function getCentralFuneralHomeSettings() {
  const callable = httpsCallable<
    undefined,
    { settings: CentralFuneralHomeSettings }
  >(functions, "getCentralFuneralHomeSettings");
  return (await callable(undefined)).data.settings;
}
export async function saveCentralFuneralHomeSettings(
  input: Omit<CentralFuneralHomeSettings, "updatedAt">,
) {
  const callable = httpsCallable<typeof input, { saved: true }>(
    functions,
    "saveCentralFuneralHomeSettings",
  );
  return (await callable(input)).data;
}
export function getCentralFuneralHomeSettingsErrorMessage(
  error: unknown,
  action: "load" | "save" = "save",
) {
  const code =
    typeof error === "object" && error && "code" in error
      ? String(error.code)
      : "";
  const message =
    typeof error === "object" && error && "message" in error
      ? String(error.message).replace(/^FirebaseError:\s*/i, "")
      : "";
  if (code.includes("permission-denied"))
    return action === "load"
      ? "Your account cannot view funeral home settings."
      : "Your account cannot edit funeral home settings.";
  if (code.includes("invalid-argument"))
    return message || "Review the name, phone, address, and HTTPS website.";
  return action === "load"
    ? "Funeral home settings could not be loaded. Try again."
    : "Funeral home settings could not be saved. No settings were changed. Try again.";
}
